import { create } from "zustand";
import { uuidv4 } from "../utils";

export interface Measurement {
  id: string;
  // Coordinates stored in feet (content space) for zoom-reactive positioning
  startPointFeet: { x: number; y: number };
  endPointFeet: { x: number; y: number };
  isConstrained: boolean;
}

interface MeasuringToolState {
  active: boolean;
  setActive: (active: boolean) => void;

  // Multi-measurement
  measurements: Measurement[];
  addMeasurement: (measurement: Omit<Measurement, "id">) => void;
  removeMeasurement: (id: string) => void;
  clearAllMeasurements: () => void;

  // Selection
  selectedMeasurementId: string | null;
  setSelectedMeasurementId: (id: string | null) => void;
}

export const useMeasuringToolState = create<MeasuringToolState>()((set, get) => ({
  active: false,
  setActive: (active) => {
    if (!active) {
      // Clear all measurements when deactivating the tool
      set({ active, measurements: [], selectedMeasurementId: null });
    } else {
      set({ active });
    }
  },

  // Multi-measurement
  measurements: [],
  addMeasurement: (measurement) => {
    set((state) => ({
      measurements: [...state.measurements, { ...measurement, id: uuidv4() }],
    }));
  },
  removeMeasurement: (id) => {
    set((state) => ({
      measurements: state.measurements.filter((m) => m.id !== id),
      selectedMeasurementId:
        state.selectedMeasurementId === id ? null : state.selectedMeasurementId,
    }));
  },
  clearAllMeasurements: () => {
    set({ measurements: [], selectedMeasurementId: null });
  },

  // Selection
  selectedMeasurementId: null,
  setSelectedMeasurementId: (id) => set({ selectedMeasurementId: id }),
}));
